export const regEmail = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,20}$/i);

export const regNumber = new RegExp(/^[0-9\b]+$/);

export const regIsSpace = new RegExp(/(^\s+)/g);
